import { ChartContainer } from "@mui/x-charts/ChartContainer";
import {
  LinePlot,
  lineElementClasses,
  markElementClasses,
} from "@mui/x-charts/LineChart";

function PlayerStats({ player, period, showCharts }) {
  function doLineChart(param, colour) {
    if (!player.playerSensorData || !player.playerSensorData[period - 1]) {
      return <></>;
    }
    let xpData = [];
    let xxLabels = [];
    let pData = [];
    let xLabels = [];
    let lastts = 0;
    for (var sd of player.playerSensorData[period - 1].data) {
      if (sd.ts === lastts) {
        continue;
      }
      if (sd.ts > player.sensorData.ts) {
        pData = xpData.slice(-50);
        xLabels = xxLabels.slice(-50);
        break;
      }
      xpData.push(sd[param]);
      xxLabels.push(sd.ts + sd.cs / 100);
      lastts = sd.ts;
    }
    return (
      <ChartContainer
        skipAnimation
        width={100}
        height={24}
        series={[{ type: "line", data: pData }]}
        xAxis={[{ scaleType: "point", data: xLabels, position: "none" }]}
        yAxis={[{ position: "none" }]}
        sx={{
          [`& .${lineElementClasses.root}`]: {
            stroke: colour,
            strokeWidth: 1.5,
          },
          [`& .${markElementClasses.root}`]: {
            stroke: colour,
            r: 0.5, // Modify the circle radius
            fill: colour,
            strokeWidth: 0.5,
          },
          border: 1,
          borderColor: "var(--b1)",
          backgroundColor: "black",
        }}
        disableAxisListener
      >
        <LinePlot />
        {/* <MarkPlot /> */}
      </ChartContainer>
    );
  }

  return (
    <>
      <div className="flex-col shadow-lg rounded-xl">
        {/* <div className="flex gap-2 text-lg font-bold px-2">
          {player?.first_name} {player?.last_name}
        </div> */}
        <div
          className="grid grid-cols-3 shadow-lg bg-base-200/80"
          style={{ rowHeight: "200px" }}
        >
          <div className="col-span-1 p-4">
            <div className="flex-col text-center">
              <div className="text-xs">Odometer</div>
              {showCharts ? (
                <div className="flex-col">
                  <div style={{ position: "relative", left: "-10px" }}>
                    {doLineChart("o", "oklch(var(--a))")}
                  </div>
                  <div className="stat-desc text-base-content">{player?.sensorData?.o}</div>
                </div>
              ) : (
                <div className="text-2xl text-accent font-extrabold">
                  {player?.sensorData
                    ? (player?.sensorData?.o / 1000).toFixed(3)
                    : ""}
                </div>
              )}
            </div>
          </div>
          <div className="col-span-1 p-4">
            <div className="flex-col text-center">
              <div className="text-xs">Velocity</div>{" "}
              {showCharts ? (
                <div className="flex-col">
                  <div style={{ position: "relative", left: "-10px" }}>
                    {doLineChart("v", "oklch(var(--p))")}
                  </div>
                  <div className="stat-desc text-base-content">{player?.sensorData?.v}</div>
                </div>
              ) : (
                <div className="text-2xl text-primary font-extrabold">
                  {player?.sensorData?.v}
                </div>
              )}
            </div>
          </div>
          <div className="col-span-1 p-4">
            <div className="flex-col text-center">
              <div className="text-xs">Acceleration</div>
              {showCharts ? (
                <div className="flex-col">
                  <div style={{ position: "relative", left: "-10px" }}>
                    {doLineChart("a", "oklch(var(--s))")}
                  </div>
                  <div className="stat-desc text-base-content">{player?.sensorData?.a}</div>
                </div>
              ) : (
                <div className="text-2xl text-secondary font-extrabold">
                  {player?.sensorData?.a}
                </div>
              )}
            </div>
          </div>
          <div className="col-span-1 p-4">
            <div className="flex-col text-center">
              <div className="text-xs">Player Load</div>
              {showCharts ? (
                <div className="flex-col">
                  <div style={{ position: "relative", left: "-10px" }}>
                    {doLineChart("pl", "oklch(var(--er))")}
                  </div>
                  <div className="stat-desc text-base-content">{player?.sensorData?.pl}</div>
                </div>
              ) : (
                <div className="text-2xl text-error font-extrabold">
                  {player?.sensorData?.pl}
                </div>
              )}
            </div>
          </div>
          <div className="col-span-1 p-4">
            <div className="flex-col text-center">
              <div className="text-xs">Meta. Power</div>
              {showCharts ? (
                <div className="flex-col">
                  <div style={{ position: "relative", left: "-10px" }}>
                    {doLineChart("mp", "oklch(var(--in))")}
                  </div>
                  <div className="stat-desc text-base-content">{player?.sensorData?.mp}</div>
                </div>
              ) : (
                <div className="text-2xl text-info font-extrabold">
                  {player?.sensorData?.mp}
                </div>
              )}
            </div>
          </div>
          <div className="col-span-1 p-4">
            <div className="flex-col text-center">
              <div className="text-xs">Smooth Load</div>
              {showCharts ? (
                <div className="flex-col">
                  <div style={{ position: "relative", left: "-10px" }}>
                    {doLineChart("sl", "oklch(var(--su))")}
                  </div>
                  <div className="stat-desc text-base-content">{player?.sensorData?.sl}</div>
                </div>
              ) : (
                <div className="text-2xl text-success font-extrabold">
                  {player?.sensorData?.sl}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PlayerStats;
